import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor } from 'src/app/models/visitor';
import { IPostComments } from 'src/app/models/notice-board';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-printable-activity-dialog',
  templateUrl: './printable-activity-dialog.component.html',
  styleUrl: './printable-activity-dialog.component.scss',
})
export class PrintableActivityDialogComponent {
  visitorTableData: Visitor[];
  filtered: Visitor[];
  screen: ScreenType;
  ScreenType = ScreenType;
  isShowPrintPreview = false;
  orgName = localStorage.getItem('OrganizationName');
  printedBy = localStorage.getItem('FullName');
  printedByRole = localStorage.getItem('Role');
  visitorName = '';
  profilePic = '';
  today = new Date();
  activity: IPostComments[] = [];
  displayedVisitorColumns = [
    'no',
    'id',
    'name',
    'contact',
    'host',
    'security',
    'Details',
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PrintableActivityDialogComponent>
  ) {
    // this.visitorTableData = data.visitors;
    const visitorMap = new Map();

    data.visitors.forEach((visitor: Visitor) => {
      if (!visitorMap.has(visitor.visitorID)) {
        visitorMap.set(visitor.visitorID, visitor);
      }
    });
    this.visitorTableData = Array.from(visitorMap.values());
    this.filtered = Array.from(visitorMap.values());
    this.screen = data.screen;
  }
  onShowDetails(val: Visitor) {
    this.visitorName = val.firstName + ' ' + val.lastName;
    this.profilePic = val.profilePicture;
    let activity = [...val.visitorComments];
    this.activity = activity.reverse();
    this.isShowPrintPreview = true;
  }
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    // Filter the temp array
    this.filtered = this.visitorTableData.filter((visitor) => {
      const firstNameMatch = visitor.firstName
        .trim()
        .toLowerCase()
        .includes(filterValue);
      const visitorIdMatch = visitor.visitorID.toString().includes(filterValue); // Assuming visitorId is a number
      const securityStatusMatch = visitor.securityStatus
        .toString()
        .includes(filterValue); // Assuming securityStatus is a number

      return firstNameMatch || visitorIdMatch || securityStatusMatch;
    });
  }
  isClickedPrinting = false;
  printDocument() {
    this.isClickedPrinting = true;
    setTimeout(() => {
      const data = document.getElementById('printable-area');
      if (data) {
        this.isClickedPrinting = false;
        // Define DPI and calculate scale
        const dpi = 200; // Desired DPI
        const scale = dpi / 96; // html2canvas default is 96 DPI
        const margin = 15; // 15mm margins
        const marginPx = (margin * dpi) / 25.4;
        html2canvas(data, { useCORS: true, scale }).then((canvas) => {
          const pageWidthPx = (210 * dpi) / 25.4; // A4 width in pixels
          const pageHeightPx = (295 * dpi) / 25.4; // A4 height in pixels
          const imgWidthPx = pageWidthPx - 2 * marginPx; // Content width with margins
          const imgHeightPx = pageHeightPx - 2 * marginPx; // Content height with margins

          const imgHeight = (canvas.height * imgWidthPx) / canvas.width;
          const pdf = new jsPDF('p', 'px', [pageWidthPx, pageHeightPx]);
          let position = 0;

          // Generate multi-page PDF
          const pageHeightPxAdjusted =
            pdf.internal.pageSize.height - 2 * marginPx;
          let heightLeft = imgHeight;

          while (heightLeft > 0) {
            pdf.addImage(
              canvas.toDataURL('image/png'),
              'PNG',
              marginPx, // Positioning X with margin
              marginPx + position, // Positioning Y with margin
              imgWidthPx,
              imgHeightPx
            );
            heightLeft -= pageHeightPxAdjusted;
            position -= pageHeightPxAdjusted;
            if (heightLeft > 0) {
              pdf.addPage();
            }
          }

          pdf.save('report.pdf');
          this.isShowPrintPreview = false;
        });
      }
    }, 250);
  }
}
